import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import CircularLoader from "../../../common/CircularLoader/CircularLoader";
import { BiCalendar, BiPlus } from "react-icons/bi";
import { LOADER_STATUS } from "../../../../Constants/constant";
import AppointmentModal from "./AppointmentsModal";
import CustomButton from "../../../common/Button/CustomButton";
import AppointmentItem from "./AppointmentItem";
import { LoginContext } from "helpers/LoginContext";

const Appointments = (props) => {
  const {
    participantInfo,
    getAppointments,
    appointmentList,
    isLoading,
    type,
    updateAppointment,
    participantAppointmentDeleteLocally,
  } = props;
  const { uuid } = useParams(); // Gets the uuid parameter from the URL (e.g.,/sp-profile/00ce111a-56e9-4111-b9be-fb3a0c1b1277).

  const { isUserGracePeriodOver } = useContext(LoginContext);

  const [participantAppointment, setParticipantAppointment] = useState([]);
  const [fetchLoader, setFetchLoader] = useState(LOADER_STATUS.NA);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
 
  useEffect(() => {
    if (appointmentList) {
      setParticipantAppointment(appointmentList);
    }
  }, [appointmentList]);

  useEffect(() => {
    if (!isLoading && fetchLoader === LOADER_STATUS.PENDING) {
      setFetchLoader(LOADER_STATUS.COMPLATE);
    }
  }, [isLoading]);

  useEffect(() => {
    if (uuid && appointmentList.length === 0 && type === "page_render") {
      setFetchLoader(LOADER_STATUS.PENDING);
      getAppointments({ uuid });
    }
  }, []);

  const refreshAppointments = () => {
    setFetchLoader(LOADER_STATUS.PENDING);
    getAppointments({ uuid });
  };
  

  if (type && type === "header_button") {
    return (
      <>
        <CustomButton
          clickHandler={() => setIsOpen(true)}
          label='Appointment'
          Icon={<BiPlus />}
        />
        {isOpen && (
          <AppointmentModal
            isUserGracePeriodOver={isUserGracePeriodOver}
            isOpen={isOpen}
            closeModal={() => setIsOpen(false)}
            participantInfo={participantInfo}
          />
        )}
      </>
    );
  } else if (type === "page_render") {
    return (
      <>
        <div className='px-4 sm:px-6 py-4 sm:py-6'>
          {/* Appointments List */}
          <div>
            {isLoading ? (
              <div className='flex justify-center items-center w-full bg-white border border-gray-200 rounded-xl shadow-sm py-16'>
                <CircularLoader
                  classes='flex justify-center items-center'
                  classloader='loader-l'
                />
              </div>
            ) : participantAppointment.length > 0 ? (
              <div className='bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden'>
                <div className='divide-y divide-gray-100'>
                  {participantAppointment.map((meeting, index) => (
                    <AppointmentItem
                      key={index}
                      index={index}
                      meeting={meeting}
                      setSelectedAppointment={setSelectedAppointment}
                      setIsOpen={setIsOpen}
                      participantAppointmentDeleteLocally={
                        participantAppointmentDeleteLocally
                      }
                      isUserGracePeriodOver={isUserGracePeriodOver}
                      refreshAppointments={refreshAppointments}
                    />
                  ))}
                </div>
              </div>
            ) : (
              <div className='py-16 flex justify-center items-center bg-white border border-gray-200 rounded-xl shadow-sm'>
                <div className='flex flex-col justify-center items-center space-y-4'>
                  <div className='w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center'>
                    <BiCalendar className='h-8 w-8 text-gray-400' />
                  </div>
                  <div className='text-center'>
                    <p className='font-semibold text-gray-600 text-base'>No Appointments Found!</p>
                    <p className='text-sm text-gray-500 mt-1'>Schedule an appointment to get started.</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {isOpen && selectedAppointment && (
          <AppointmentModal
            isUserGracePeriodOver={isUserGracePeriodOver}
            isUpdate={true}
            appointment={selectedAppointment}
            isOpen={isOpen}
            closeModal={() => setIsOpen(false)}
            participantInfo={participantInfo}
            updateAppointment={updateAppointment}
          />
        )}
      </>
    );
  }
};

export default Appointments;
